"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mmdb = require("maxmind");
const errors_1 = require("./errors");
const readerModel_1 = require("./readerModel");
class Reader {
    static open(file, opts) {
        return mmdb.open(file, opts).then((reader) => new readerModel_1.default(reader));
    }
    static openBuffer(buffer) {
        let reader;
        try {
            reader = new mmdb.Reader(buffer);
        }
        catch (e) {
            throw new errors_1.InvalidDbBufferError(e);
        }
        return new readerModel_1.default(reader);
    }
}
exports.default = Reader;
